import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { getFoundationDataContext } from '../app/bootstrap-foundation';
import { LayoutData } from '../app/types';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

class ConfigurationService {

  static getConfigurationData(): Promise<LayoutData> {
    const foundationContext = getFoundationDataContext();
    const configInContext = foundationContext.get('applicationConfig');

    if(configInContext) {
      return new Promise((resolve) => resolve(configInContext));
    }

    return HttpService.get(APPLICATION_ENDPOINTS.GET_CONFIGURATION).then(response => {
      foundationContext.set({applicationConfig: response.body})
      return response.body as LayoutData
    });
  }

}

export default ConfigurationService;